// extracted by mini-css-extract-plugin
export default {"container":"container-u8HO10AZ","triangleWrapper":"triangleWrapper-HnuoQX9w","hidden":"hidden-aCPYhmnW"};